import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';

import { hideResidentsCheck } from '../../../utilities/Generic.js'
import { request, handleRequestErrors } from '../../../helpers/Requests'

class DailyArrivals extends Component {
  removeResidentsIfNeeded(array) {
    if (this.state.hideResidents) {
      // Residents are the second item in the arrays, so we can just filter them out directly by position
      array.splice(1, 1)
    }

    return array
  }

  render() {
    const { json, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const days = json.map((day) => (day.day))
      const visitors = json.map((day) => (day.visitors))
      const residents = json.map((day) => (day.residents))
      const staff = json.map((day) => (day.staff))
      const contractors = json.map((day) => (day.contractors))
      const industry_professionals = json.map((day) => (day.industry_professionals))
      const agencies = json.map((day) => (day.agencies))
      const volunteers = json.map((day) => (day.volunteers))
      const other = json.map((day) => (day.other))

      const data = {
        labels: days,
        datasets: this.removeResidentsIfNeeded([{
          label: 'Visitors',
          data: visitors,

          backgroundColor: '#eee622'
        }, {
          label: 'Residents',
          data: residents,

          backgroundColor: '#22ee80'
        }, {
          label: 'Staff',
          data: staff,

          backgroundColor: '#222aee'
        }, {
          label: 'Contractors',
          data: contractors,

          backgroundColor: '#ee2290'
        }, {
          label: 'Industry Professionals',
          data: industry_professionals,

          backgroundColor: '#b80c09'
        }, {
          label: 'Agencies',
          data: agencies,

          backgroundColor: '#20c7d4'
        }, {
          label: 'Volunteers',
          data: volunteers,

          backgroundColor: '#ff8819'
        }, {
          label: 'Other',
          data: other,

          backgroundColor: '#8826bf'
        }])
      }

      return (
        <div className="widget">
          <h3>Daily Arrivals chart</h3>
          <Bar data={data} width={500} height={300} />
        </div>
      );
    }
  }

  state = {
    json: [],
    hideResidents: false,
    loaded: false,
    error: null,
    unauthorized: null
  };

  componentDidMount() {
    var id = this.props.id;

    request("GET", `/v1/a/locations/${id}/daily_arrivals`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ json: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    this.setState({
      hideResidents: hideResidentsCheck()
    })
  }
}

export default DailyArrivals;
